export default __webpack_public_path__ + "static/media/server-error.7f1d730e.svg";